var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9219 9.96094C19.9219 15.4004 15.4102 19.9219 9.96094 19.9219C4.52148 19.9219 0 15.4004 0 9.96094C0 4.51172 4.51172 0 9.95117 0C15.4004 0 19.9219 4.51172 19.9219 9.96094ZM8.47656 5.94727L5.07812 9.36523C4.87305 9.57031 4.79492 9.72656 4.79492 9.95117C4.79492 10.1758 4.89258 10.3516 5.07812 10.5371L8.47656 13.9453C8.61328 14.082 8.78906 14.1602 9.00391 14.1602C9.42383 14.1602 9.73633 13.8379 9.73633 13.418C9.73633 13.2031 9.64844 13.0176 9.51172 12.8809L8.26172 11.6406L7.04102 10.625L9.17969 10.7031H14.4043C14.8535 10.7031 15.166 10.3906 15.166 9.95117C15.166 9.50195 14.8438 9.18945 14.4043 9.18945H9.17969L7.05078 9.27734L8.26172 8.26172L9.51172 7.02148C9.63867 6.875 9.73633 6.68945 9.73633 6.47461C9.73633 6.05469 9.42383 5.74219 9.00391 5.74219C8.78906 5.74219 8.61328 5.81055 8.47656 5.94727Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left_arrow_icon.d3ce96d9ba47fd65e2c2e98d817f1bd6.svg";
export { ForwardRef as ReactComponent };